import { render } from "./DrawerLayout.vue?vue&type=template&id=a5938fa4&scoped=true"
import script from "./DrawerLayout.vue?vue&type=script&lang=js"
export * from "./DrawerLayout.vue?vue&type=script&lang=js"

import "./DrawerLayout.vue?vue&type=style&index=0&id=a5938fa4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5938fa4"]])

export default __exports__